module.exports = __GETREMOTE__('RECEIPTS');